export const SINGLE_SELECT_ID_PREFIX = 'single-select-option';
export const SINGLE_SELECT_LABEL = 'single-select-label';
